/**
 * Connector Service - Handles API interactions for Connector management
 */

import { post, put } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_persistence/connectors`;


/**
 * Get all Connectors bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const getAllConnectorsByFilter = async (filter = {}, sort ={}, query = null) => {
  try {
    const response = await post(`${API_URL}/fetch?query=${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching connector:', error);
    throw error;
  }
};

/**
 * Get a specific connectors by ID
 * @param {string} connectorsId - connectors ID
 * @returns {Promise<Object>} Promise resolving to connectors object
 */
export const getConnectorById = async (connectorsId) => {
  let filter = {
    id: connectorsId
  }
  let sort ={}
  try {
    const response = await post(`${API_URL}/fetch`, { filter, sort });
    if(response && response.length > 0) {
      return response[0];
    }else{
      return null;
    }
  } catch (error) {
    console.error('Error fetching connector:', error);
    throw error;
  }
};


/**
 * Update a specific connectors
 * @param {string} connectors - connectors
 * @returns {Promise<Object>} Promise resolving to connectors object
 */
export const updateConnector = async (connectors) => {
  
  try {
    const response = await put(`${API_URL}`, connectors);
    return response;
  } catch (error) {
    console.error('Error fetching connector:', error);
    throw error;
  }
};


/**
 * Update a specific connectors
 * @param {string} connectors - connectors
 * @returns {Promise<Object>} Promise resolving to connectors object
 */
export const createConnector = async (connectors) => {
  
  try {
    const response = await post(`${API_URL}`, connectors);
    return response;
  } catch (error) {
    console.error('Error fetching connector:', error);
    throw error;
  }
};



export default {
  getAllConnectorsByFilter
};

